export default __webpack_public_path__ + "static/segmently-image-b89f22423ed5df146bdfd02bbf9ddf53.png";